import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { useCallback } from 'react'

/**
 * Hook to reset track changes and suggestion data.
 *
 * @returns {(shouldResetTrackChanges: boolean) => void} - A function to reset track changes.
 */
export const useTrackChangesReset = () => {
    const {
        setTrackChangesData,
        removeAllSuggestionData,
    } = useSuggestionsShallowSelector((s) => ({
        setTrackChangesData: s.setTrackChangesData,
        removeAllSuggestionData: s.removeAllSuggestionData,
    }))

    const resetTrackChanges = useCallback(
        (
            shouldResetTrackChanges: boolean | undefined,
            shouldResetSuggestionsData?: boolean
        ) => {
            if (shouldResetTrackChanges) {
                setTrackChangesData({})
                removeAllSuggestionData()
            }

            if (shouldResetSuggestionsData) {
                removeAllSuggestionData()
            }
        },
        [setTrackChangesData, removeAllSuggestionData]
    )

    return resetTrackChanges
}
